<template>
  <b-alert show :variant="variant">
    <div class=" content-container row mt-3 mb-3">
      <div v-if="fa" class="text-center col-auto">
        <i :class="faicon" aria-hidden="true"></i>
      </div>

      <div class="text-content col">
        <div class="title">{{ title }}</div>
        <div class="text">{{ text }}</div>
      </div>
    </div>
  </b-alert>
</template>

<script>
import "../../assets/scss/alert.scss";

export default {
  name: "alert-simple",
  props: {
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    variant: {
      type: String,
      default: "primary",
    },
    fa: {
      type: String,
      default: "",
    },
  },
  computed: {
    faicon() {
      if (this.fa) {
        return {
          [`icon fa fa-${this.fa}`]: true,
        };
      } else {
        return "";
      }
    },
  },
};
</script>
